import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsComponent } from './charts.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { BasicLinebarChartComponent } from './basic-linebar-chart/basic-linebar-chart.component';
import { DynamicAnchorDirective } from './directives/dynamic-anchor.directive';
import { BoxChartComponent } from './box-chart/box-chart.component';
import { PercentageBarChartComponent } from './percentage-bar-chart/percentage-bar-chart.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ChartsComponent,
    DynamicAnchorDirective,
    BasicLinebarChartComponent,
    PercentageBarChartComponent,
    BoxChartComponent
  ],
  imports: [
    CommonModule,
    NgxEchartsModule,
    TranslateModule
  ],
  exports: [
    ChartsComponent,
    BasicLinebarChartComponent,
    PercentageBarChartComponent,
    BoxChartComponent
  ]
})
export class ChartsModule { }
